import styles from "./AlergenCard.module.css"
/**
* Props for the Alergen component.
*/ 
interface AlergenProps {
    title: string, // Title
    desc?: string // Optional description
}
/**
* A card for displaying allergen.
*
* @param props Alergen props
* @param {string} props.title - Title
* @param {string} props.desc - Optional description
* @returns TSX.Element
*/
const Alergen = ({title, desc} : AlergenProps) => {

    return(
        <>
            <div className={styles.Alergen}>
                <p>{title}</p>
                {desc && <span className={styles.Tooltip}>{desc}</span>}
            </div>
        </>
    )
}
export default Alergen;